import React from "react";
import { Box, Button, Typography } from "@mui/material";
import fallbackImg from "../../../src/assets/images/app-error.png";
import fallbacklogo from "../../../src/assets/images/fallback_logo.png";
import CustomeDivider from "./CustomeDivider";
import {
  buttonFontColor,
  ButtonandLeftBarColor,
} from "../../constants/styleConstant";
import { useNavigate } from "react-router-dom";

const FallbackError = () => {
  const navigate = useNavigate();

  const reloadPage = () => {
    window.location.reload();
  };

  const goBack = () => {
    navigate(-1);
    setTimeout(() => window.location.reload(), 400);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f3f4f6",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          p: 4,
          maxWidth: 1200,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: 500,
        }}
      >
        <img
          src={fallbackImg}
          alt="Error"
          style={{ width: 180, marginBottom: 20 }}
        />
        <img
          src={fallbacklogo}
          alt="Powered by simplify"
          style={{ width: 180, marginBottom: 20 }}
        />
        <CustomeDivider />

        <Typography variant="h4" component="h1" gutterBottom>
          Woops!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Something went wrong :(
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Have you tried turning it off and on again?
        </Typography>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{
              color: ButtonandLeftBarColor,
              borderColor: ButtonandLeftBarColor,
            }}
            onClick={goBack}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{ color: buttonFontColor, bgcolor: ButtonandLeftBarColor }}
            onClick={reloadPage}
          >
            Reload
          </Button>
          <Button
            variant="text"
            sx={{ color: ButtonandLeftBarColor }}
            onClick={() => (window.location.href = "/")}
          >
            Go Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default FallbackError;
